import { icon } from '@carvana/ds-styles';
import { AlertCircle } from 'lucide-react';

type OwnProps = {
  hasOpenVerifications: boolean;
  openVerificationsCount: number;
};

export const RemainingTasks = ({
  openVerificationsCount,
  hasOpenVerifications
}: OwnProps) => {
  const taskCount =
    openVerificationsCount > 1
      ? `${openVerificationsCount} tasks`
      : `${openVerificationsCount} task`;

  return hasOpenVerifications ? (
    <div className="flex items-center gap-md">
      <AlertCircle color={icon.warning} />
      <span className="text-text-strong t-heading-sm">
        You have {taskCount} to complete.
      </span>
    </div>
  ) : null;
};
